import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { InnModalPopup } from "../innModalPopup";
import backArrowIcon from "../../assets/images/top-back-arrow.svg";
import calenderIcon from "../../assets/images/top-calender-icon.svg";
import buldingIcon from "../../assets/images/top-building-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { documentupload, propertyDetails, reservationData } from "../../reducer/selfCheckinSlice";
import moment from "moment";
import { InnLoader } from "../innLoader";
import PdfViewer from "./PdfViewer";

function Preview(props) {
    const objImageInfo = useSelector(documentupload)
    const propertyDetailObj = useSelector(propertyDetails);
    const navigate = useNavigate();
    const [isActive, setIsActive] = useState(false);
    const [showCalenderData, setShowCalenderData] = useState(false);
    const [frontPageImage, setFrontPageImage] = useState();
    const [backPageImage, setBackPageImage] = useState();
    const [immigrationImage, setImmigrationImage] = useState();
    const [documentType, setDocumentType] = useState();
    const [visaImage, setVisaImage] = useState();
    const guestDetailObj = useSelector(reservationData);
    const dispatch = useDispatch();
    const wait = timeOut => {
        return new Promise(resolve => setTimeout(resolve, timeOut));
    }

    useEffect(() => {
        // console.log("propertdetailobj", propertyDetailObj)
    }, [])

    useEffect(() => {
        setIsActive(true);
        // console.log("propertdetailobj", propertyDetailObj)
        // if (propertyDetailObj === undefined) {
        //     navigate("/Unauthorised")
        // }
        setFrontPageImage(objImageInfo.frontPagePhoto?.fpath);
        setBackPageImage(objImageInfo.backPagePhoto?.fpath)
        setImmigrationImage(objImageInfo.immigrationImage?.fpath)
        setVisaImage(objImageInfo.visaStampImage?.fpath)
        setDocumentType(objImageInfo?.documentType);
        //console.log("Image path is here ---", frontPageImage, '\n', backPageImage, '\n', immigrationImage, '\n', visaImage, '\n', documentType);
        wait(1000).then(() => setIsActive(false))
    }, [objImageInfo, frontPageImage, backPageImage, immigrationImage, visaImage, documentType])

    return (
        <div className="modal-content medium-popup" style={{ overflowX: 'hidden', overflowY: 'scroll' }}>
            <div>
                {/* <InnLoader className={isActive ? "active" : null}></InnLoader> */}
                <div>
                    <div className="top-blue-bg" style={{ position: 'relative', justifyContent: "center", textAlign: "center" }}>
                        {/* <Link to="/Registration"> */}
                        {/* <div className="top-back-arrow">
                            <img src={backArrowIcon} onClick={() => {
                                navigate("/Registration", { state: { path: 'Preview' } });
                                props.onBack()
                            }} />
                        </div> */}
                        {/* </Link> */}
                        <div>  
                            {/* <h2 >Front Side</h2>className="top-blue-hdng" */}
                            {
                                frontPageImage !== undefined ?
                                    <h2 >Front Side</h2>
                                    :
                                    backPageImage !== undefined ?
                                        <h2 >Back Side</h2>
                                        :
                                        visaImage !== undefined ?
                                            <h2 >Visa Stamp</h2>
                                            :
                                            immigrationImage !== undefined ?
                                                <h2 >Immigration Stamp</h2>
                                                :
                                                <></>
                            }
                        </div>
                        {/* <div className="top-blue-bg-icon">
                            <div>
                                <img
                                    onClick={() => setShowCalenderData(!showCalenderData)}
                                    src={calenderIcon}
                                />
                            </div>

                            <Link to="/HomeInfo">
                                <div style={{ marginLeft: 10 }}>
                                    <img src={buldingIcon} />
                                </div>
                            </Link>
                        </div> */}
                    </div>
                    <div className="upload-top">
                        {/* <h3 className="m-tp90">Front Side</h3> */}
                        {
                            frontPageImage !== undefined ?
                                <h3 >Front Side</h3>
                                :
                                backPageImage !== undefined ?
                                    <h3 >Back Side</h3>
                                    :
                                    visaImage !== undefined ?
                                        <h3 >Visa Stamp</h3>
                                        :
                                        immigrationImage !== undefined ?
                                            <h3 >Immigration Stamp</h3>
                                            :
                                            <></>
                        }
                        <ul >
                            <li >Photo of face should be on the
                                {
                                    frontPageImage !== undefined ?
                                        <> Front Side </>
                                        :
                                        backPageImage !== undefined ?
                                            <> Back Side </>
                                            :
                                            visaImage !== undefined ?
                                                <> Visa Stamp </>
                                                :
                                                immigrationImage !== undefined ?
                                                    <> Immigration Stamp </>
                                                    :
                                                    <></>
                                }

                                of your ID</li>
                            <li >Please ensure the uploaded image is legible</li>
                        </ul>
                    </div>
                    {
                        frontPageImage !== undefined ?
                            <div className="adhar-img" >
                                {
                                    documentType === 'application/pdf' ?
                                        <PdfViewer pdfUrl={frontPageImage?.fpath !== undefined ? frontPageImage?.fpath : frontPageImage} />
                                        :
                                        <img src={frontPageImage?.fpath !== undefined ? frontPageImage?.fpath : frontPageImage} style={{ maxWidth: 400, width: '100%' }} />
                                }
                            </div>
                            :
                            backPageImage !== undefined ?
                                <div className="adhar-img">
                                    {
                                        documentType === 'application/pdf' ?
                                            <PdfViewer pdfUrl={backPageImage?.fpath !== undefined ? backPageImage?.fpath : backPageImage} />
                                            :
                                            <img src={backPageImage?.fpath !== undefined ? backPageImage?.fpath : backPageImage} style={{ maxWidth: 400, width: '100%' }} />
                                    }
                                </div>
                                :
                                visaImage !== undefined ?
                                    <div className="adhar-img">
                                        {
                                            documentType === 'application/pdf' ?
                                                <PdfViewer pdfUrl={visaImage?.fpath !== undefined ? visaImage?.fpath : visaImage} />
                                                :
                                                <img src={visaImage?.fpath !== undefined ? visaImage?.fpath : visaImage} style={{ maxWidth: 400, width: '100%' }} />
                                        }
                                    </div>
                                    :
                                    immigrationImage !== undefined ?
                                        <div className="adhar-img">
                                            {
                                                documentType === 'application/pdf' ?
                                                    <PdfViewer pdfUrl={immigrationImage?.fpath !== undefined ? immigrationImage?.fpath : immigrationImage} />
                                                    :
                                                    <img src={immigrationImage?.fpath !== undefined ? immigrationImage?.fpath : immigrationImage} style={{ maxWidth: 400, width: '100%' }} />
                                            }
                                        </div>
                                        :
                                        <></>
                    }
                </div>

                <div className="overlay">
                    <div className="overlay-background"></div>
                    {/* <div className="overlay-content"><span
                    className="spinner"></span>&nbsp;&nbsp;&nbsp;Loading
                </div> */}
                </div>
                <div className="hidden">
                    <div className="loader-overlay"></div>
                </div>

                {showCalenderData ? (
                    <InnModalPopup Onclose={() => setShowCalenderData(false)}>
                        <div class="modal-content x-small-popup">
                            <div
                                id="myModal3"
                                tabindex="-1"
                                role="dialog"
                                aria-labelledby="myModalLabel3"
                                class="model-popup"
                            >
                                <div role="document">
                                    <div class="reg-detail text-left">
                                        <h2>{guestDetailObj?.GuestName}</h2>
                                    </div>
                                    <div class="reg-detail p-btm30">
                                        <div class="wdth50 bdr-rgt">
                                            <p>{moment(new Date(guestDetailObj?.Arrival_Date)).format("DD MMM")} - {moment(new Date(guestDetailObj?.Departure_Date)).format("DD MMM")}</p>
                                            <p>{guestDetailObj?.No_Of_Nights} Nights</p>
                                        </div>
                                        <div class="wdth50">
                                            <p class="text-right">Booking No: {guestDetailObj?.Booking_No}</p>
                                            <p class="text-right">{guestDetailObj?.No_Of_Rooms} Room {guestDetailObj?.Adult} Adults</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </InnModalPopup>
                ) : null}

            </div>
        </div>
    )
}

export default Preview